import { useOutletContext } from "react-router-dom";

import { CompetencyTestContextType } from "../typings";

export const useCompetencyTestContext = () =>
    useOutletContext<CompetencyTestContextType>();
